module.exports = __webpack_public_path__ + "img/center.92a70592.png";